// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Quicksand', 'Quicksand Fallback'","fontStyle":"normal"},"className":"__className_572227","variable":"__variable_572227"};